export function getSeoAlt(productName: string | undefined, brandName: string | undefined, colorName?: string | undefined) {
  if (!productName && !brandName) {
    return '';
  }

  let altAttribute = '';
  if (brandName) {
    altAttribute += `${brandName} `;
  }
  altAttribute += productName;
  if (colorName && colorName !== 'No Color') {
    altAttribute += ` ${colorName}`;
  }
  return altAttribute;
}

export default getSeoAlt;
